
import { supabase } from "@/integrations/supabase/client";
import { NavigateFunction } from "react-router-dom";
import { clearProfileSnapshot } from "@/lib/profileSnapshot";
import { clearAllIosflowState, clearAllV2State } from "@/lib/iosflow-storage";

export const cleanupAuthState = () => {
  // Remove standard auth tokens
  localStorage.removeItem('supabase.auth.token');
  
  // Remove all Supabase auth keys from localStorage
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      localStorage.removeItem(key);
    }
  });
  
  // Remove from sessionStorage
  Object.keys(sessionStorage || {}).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      sessionStorage.removeItem(key);
    }
  });
  
  // Remove app-specific storage
  localStorage.removeItem('profile-selection-shown');
  sessionStorage.removeItem('processing-payment');
  
  // Clear the profile snapshot for instant avatar
  clearProfileSnapshot();

  // Clear all IOSFlow flags so user starts fresh onboarding on next visit
  clearAllIosflowState();
  // Clear V2 sessionStorage flags alongside V1 localStorage flags
  clearAllV2State();
  localStorage.removeItem('onboarding_completed');
  localStorage.removeItem('onboarding_completed_at');
  localStorage.removeItem('onboarding_completed_user_id');
};

export const signOutCompletely = async (navigate?: NavigateFunction, destination = '/') => {
  try {
    // Clean up auth state first
    cleanupAuthState();
    
    // Attempt global sign out
    try {
      await supabase.auth.signOut({ scope: 'global' });
    } catch (err) {
      console.warn('Sign out warning:', err);
    }
    
    // Use React Router navigation if available, otherwise fallback to window.location
    if (navigate) {
      navigate(destination, { replace: true });
    } else {
      window.location.href = destination;
    }
  } catch (error) {
    console.error('Sign out error:', error);
    // Force redirect even if error
    if (navigate) {
      navigate(destination, { replace: true });
    } else {
      window.location.href = destination;
    }
  }
};
